module.exports = __webpack_public_path__ + "static/libation-white-037228610ef2d276a43f869e46660260.png";